// extracted by mini-css-extract-plugin
module.exports = {"section":"iconSection_section__1S43k","iconsbottom":"iconSection_iconsbottom__Lkglg"};